import React from 'react';

// Spectrum Components
import Heading from '@react/react-spectrum/Heading';
import Button from '@react/react-spectrum/Button';

// I18n
import { Translate, I18n } from 'react-redux-i18n';

// Project Components
import Progress from '../global/Progress';

class ThankYouPublic extends React.Component {
  onCBCclick = () => {
    const url = I18n.t('workflow.error_page.cbc_link');
    window.open(url, '_self');
  };

  onAPCclick = () => {
    const url = I18n.t('workflow.error_page.apc_link');
    window.open(url, '_self');
  };

  render() {
    return (
      <div data-testid="thank-you-public">
        <Progress step={4} />
        <div className="page-container">
          <Heading>
            <Translate data-testid="thank-you-header" value="workflow.thank_you_page.header" />
          </Heading>
          <div>
            <p><Translate data-testid="thank-you-text" value="workflow.thank_you_page.thank_you_public" /></p>
            <p>
              <Translate data-testid="questions-contact-helpdesk" value="workflow.thank_you_page.questions_contact_helpdesk" />
            </p>
          </div>
          <div className="button-container">
            <Button data-testid="cbc-button" variant="cta" onClick={this.onCBCclick}><Translate value="workflow.error_page.cbc_button_text" /></Button>
            <Button data-testid="apc-button" variant="cta" onClick={this.onAPCclick}><Translate value="workflow.error_page.apc_button_text" /></Button>
          </div>
        </div>
      </div>
    );
  }
}

export default ThankYouPublic;
